import translate from './search-appointment.language';

class SearchAppointmentController {
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        this.translate = translate;
        this.selectedLanguage = localStorage.getItem('languaje') || "en";
    }
}

export default SearchAppointmentController;


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/search-appointment/search-appointment.controller.js
// module id = 635
// module chunks = 0